import { ADDED, LOADED, DELETED, UPDATEING, UPDATED } from "./actionType";
import initalState from "./initialState";

const bookReducer = (state = initalState, action) => {
  switch (action.type) {
    case ADDED:
      return {
        ...state,
        books: [...state.books, action.payload],
      };

    case LOADED:
      return {
        ...state,
        books: [...action.payload],
      };

    case UPDATED:
      return {
        ...state,
        books: state.books.map((book) => {
          if (book?.id === action.payload?.id) {
            return action.payload;
          }
          return book;
        }),
        updatingbook: {},
      };

    case UPDATEING:
      return {
        ...state,
        updatingbook: action.payload,
      };

    case DELETED:
      return {
        ...state,
        books: state.books.filter((book) => book.id !== action.payload),
      };

    default:
      return state;
  }
};

export default bookReducer;
